export default __webpack_public_path__ + "static/media/ialeap_original.c5f357d9.jpg";